import React from 'react';
import HeroBg from '../../images/HowItWorksPage/HH25_HowItWorks_HeroBackground.png';

// IMPORTS PARA LA SECCIÓN DE BUSCÁS TRABAJO
import JobStep1 from '../../images/HowItWorksPage/HH25_HowItWorks_Section3_IconStep1.svg';
import JobStep2 from '../../images/HowItWorksPage/HH25_HowItWorks_Section3_IconStep2.svg';
import JobStep3 from '../../images/HowItWorksPage/HH25_HowItWorks_Section3_IconStep3.svg';
import JobTipArrow from '../../images/HowItWorksPage/HH25_HowItWorks_Section3_IconTipExtra.svg';

// IMPORTS PARA LA SECCIÓN DE BUSCÁS PERSONAL (puedes migrar los require a import si lo deseas)
import Step1 from '../../images/HowItWorksPage/HH25_HowItWorks_Section2_IconStep1.svg';
import Step2 from '../../images/HowItWorksPage/HH25_HowItWorks_Section2_IconStep2.svg';
import Step3 from '../../images/HowItWorksPage/HH25_HowItWorks_Section2_IconStep3.svg';
import TipArrow from '../../images/HowItWorksPage/HH25_HowItWorks_Section2_IconTipExtra.svg';

import Section4Image from '../../images/HowItWorksPage/HH25_HowItWorks_Section4_Background.png'
import Section5IconLeftArrow from '../../images/HowItWorksPage/HH25_HowItWorks_Section5_IconLeftArrow.svg'

// IMPORTS PARA LOS FONDOS DE LAS FAQ CARDS
import FaqBg1 from '../../images/HowItWorksPage/HH25_HowItWorks_Section6_SquareBackground1.svg';
import FaqBg2 from '../../images/HowItWorksPage/HH25_HowItWorks_Section6_SquareBackground2.svg';
import FaqBg3 from '../../images/HowItWorksPage/HH25_HowItWorks_Section6_SquareBackground3.svg';
import FaqBg4 from '../../images/HowItWorksPage/HH25_HowItWorks_Section6_SquareBackground4.svg';

import Section7IconLeftArrow from '../../images/HowItWorksPage/HH25_HowItWorks_Section7_IconLeftArrow.svg'

const HowItWorksPage = () => {
  return (
    <div className="howitworks-page-container">
      <div className="howitworks-hero-section">
        <div className="howitworks-hero-bg">
          <img src={HeroBg} alt="Cómo funciona HappyHome" />
        </div>
        <div className="howitworks-hero-overlay">
          <div className="howitworks-hero-content">
            <div className="howitworks-hero-label">¿CÓMO FUNCIONA HH?</div>
            <h1 className="howitworks-hero-title">
              Conocé cómo usar <span className="howitworks-hero-title-bold">HappyHome</span>
            </h1>
            <div className="howitworks-hero-desc">
              paso a paso, tanto si <span className="howitworks-hero-desc-red">buscás personal</span><br />
              <span className="howitworks-hero-desc-yellow">para tu hogar o empresa</span>, como<br />
              <span className="howitworks-hero-desc-red">si estás buscando trabajo.</span>
            </div>
          </div>
        </div>
      </div>
      {/* Sección: Buscás personal para tu hogar */}
      <section className="howitworks-home-section">
        <div className="howitworks-home-cols">
          <div className="howitworks-home-col-left">
            <h2 className="howitworks-home-title">¿Buscás personal<br />para tu hogar?</h2>
            <div className="howitworks-home-subtitle-row">
              <span className="howitworks-home-subtitle">Encontrá el perfil ideal</span>
              <span className="howitworks-home-underline">en 3 simples pasos:</span>
            </div>
          </div>
          <div className="howitworks-home-col-right">
            <div className="howitworks-home-step-row">
              <img src={Step1} alt="Paso 1" className="howitworks-home-step-icon" />
              <div>
                <span className="howitworks-home-step-title">REGISTRATE</span>
                <div className="howitworks-home-step-desc">
                  Cargá tus datos como empleador/a. Es rápido, seguro y 100% online.<br />
                  Por $40.000, accedé a toda nuestra base de datos, chateá de forma ilimitada y publicá hasta dos ofertas laborales.<br />
                  Contratando este servicio vas a poder gestionar tus búsquedas de forma simple, directa y sin intermediarios.
                </div>
                <button className="howitworks-home-btn">CONTRATÁ EL SERVICIO</button>
              </div>
            </div>
            <div className="howitworks-home-step-row">
              <img src={Step2} alt="Paso 2" className="howitworks-home-step-icon" />
              <div>
                <span className="howitworks-home-step-title">BUSCÁ PERFILES</span>
                <div className="howitworks-home-step-desc">
                  Podés filtrar por zona, tareas, experiencia, disponibilidad y modalidad,<br />
                  y elegir según tus necesidades.
                </div>
              </div>
            </div>
            <div className="howitworks-home-step-row">
              <img src={Step3} alt="Paso 3" className="howitworks-home-step-icon" />
              <div>
                <span className="howitworks-home-step-title">CONTACTÁ DIRECTAMENTE</span>
                <div className="howitworks-home-step-desc">
                  Chateá con las personas que te interesen y coordiná entrevistas sin intermediarios.
                </div>
              </div>
            </div>
            <div className="howitworks-home-tip-row">
              <img src={TipArrow} alt="Tip extra" className="howitworks-home-tip-arrow" />
              <div>
                <span className="howitworks-home-tip-title">TIP EXTRA:</span>
                <span className="howitworks-home-tip-desc">
                  Si querés que te ayudemos con la selección, <b>escribinos por WhatsApp</b><br />
                  Hacemos búsquedas personalizadas a través de nuestro equipo de profesionales en acompañamiento familiar.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección: Buscás trabajo en casas de familia o empresas */}
      <section className="howitworks-job-section">
        <div className="howitworks-job-cols">
          <div className="howitworks-job-col-left">
            <h2 className="howitworks-job-title">
              ¿Buscás trabajo<br />
              en casas de familia<br />
              o empresas?
            </h2>
            <div className="howitworks-job-subtitle-row">
              <span className="howitworks-job-subtitle">
                Accedé a oportunidades reales
              </span>
              <span className="howitworks-job-underline">
                con pocos pasos y 100% gratis:
              </span>
            </div>
          </div>
          <div className="howitworks-job-col-right">
            <div className="howitworks-job-step-row">
              <img src={JobStep1} alt="Paso 1" className="howitworks-job-step-icon" />
              <div>
                <span className="howitworks-job-step-title">
                  REGISTRATE <u>GRATIS</u>
                </span>
                <div className="howitworks-job-step-desc">
                  Completá tu perfil con tus datos, experiencia, tareas que sabés hacer, referencias y disponibilidad.<br />
                  Cuanto más completes, <b>más oportunidades y visibilidad vas a tener.</b>
                </div>
              </div>
            </div>
            <div className="howitworks-job-step-row">
              <img src={JobStep2} alt="Paso 2" className="howitworks-job-step-icon" />
              <div>
                <span className="howitworks-job-step-title">
                  POSTULATE O RECIBÍ MENSAJES
                </span>
                <div className="howitworks-job-step-desc">
                  Podés aplicar a ofertas, escribirles para mostrar tu disponibilidad o esperar que los empleadores te escriban directamente.
                </div>
              </div>
            </div>
            <div className="howitworks-job-step-row">
              <img src={JobStep3} alt="Paso 3" className="howitworks-job-step-icon" />
              <div>
                <span className="howitworks-job-step-title">
                  COORDINÁ ENTREVISTAS Y CONSEGUÍ EL TRABAJO QUE BUSCÁS
                </span>
                <div className="howitworks-job-step-desc">
                  Conocé las condiciones, organizá entrevistas presenciales o virtuales y avanzá con seguridad.
                </div>
              </div>
            </div>
            <div className="howitworks-job-tip-row">
              <img src={JobTipArrow} alt="Tip útil" className="howitworks-job-tip-arrow" />
              <div>
                <span className="howitworks-job-tip-title">TIP ÚTIL:</span>
                <span className="howitworks-job-tip-desc">
                  Sumate a nuestra Academia <b>Happy Home.</b><br />
                  Descargá manuales, accedé a talleres y mejorá tus oportunidades laborales.<br /><br />
                  <b>Además, si tenés dudas sobre cómo hacer entrevistas o qué escribir en tu CV, contactanos por WhatsApp. ¡Estamos para ayudarte!</b>
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección visual: ¿Por qué elegir HappyHome? (solo imagen de fondo y overlay) */}
      <section className="howitworks-section4">
        <div className="howitworks-section4-bg">
          <img src={Section4Image} alt="HappyHome mascotas y familia" className="howitworks-section4-img" />
          <div className="howitworks-section4-overlay" />
        </div>
      </section>

      <section className="howitworks-section5">
        <div className="howitworks-section5-inner">
          <div className="howitworks-section5-title-block">
            <h2 className="howitworks-section5-title">
              TE CONTAMOS TODAS LAS FORMAS <span className="highlight-yellow">DE TRABAJAR</span><br />
              Y CONTRATAR CON <span className="highlight-hh">HAPPYHOME</span>
            </h2>
            <div className="howitworks-section5-subtitle">
              CONOCÉ TODAS LAS MODALIDADES DISPONIBLES<br />
              Y DESCUBRÍ CUÁL SE ADAPTA MEJOR A LO QUE NECESITÁS
            </div>
          </div>
          <div className="howitworks-section5-grid">
            <div className="howitworks-section5-col">
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Empleada doméstica:</span>
                <span className="howitworks-section5-job-desc">Realiza tareas generales del hogar como limpieza, lavado, planchado y organización.</span>
              </div>
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Niñera:</span>
                <span className="howitworks-section5-job-desc">Cuida a niños/as de distintas edades.</span>
              </div>
              <div className="howitworks-section5-row underline">
                <span className="howitworks-section5-job-title">Nurse (especialista en bebés):</span>
                <span className="howitworks-section5-job-desc">Profesionales con experiencia en el cuidado de recién nacidos o lactantes.</span>
              </div>
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Acompañante de personas mayores:</span>
                <span className="howitworks-section5-job-desc">Brindan compañía, asistencia básica y acompañamiento en tareas diarias a personas mayores, con o sin requerimientos específicos de salud.</span>
              </div>
              <div className="howitworks-section5-row underline">
                <span className="howitworks-section5-job-title">Cuidado y paseo de mascotas:</span>
                <span className="howitworks-section5-job-desc">Personas dedicadas al cuidado diario de animales: paseos, alimentación, higiene y juegos.</span>
              </div>
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Cocinera/o para casas de familia:</span>
                <span className="howitworks-section5-job-desc">Encargados de la preparación de comidas caseras según preferencias del hogar.</span>
              </div>
            </div>
            <div className="howitworks-section5-col">
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">House & Pet Sitting (Cuidado de hogar con mascotas):</span>
                <span className="howitworks-section5-job-desc">Personas que se alojan en tu hogar durante tu ausencia para cuidar tanto la casa como a las mascotas.</span>
              </div>
              <div className="howitworks-section5-row underline">
                <span className="howitworks-section5-job-title">Au Pair (Niñera con cama):</span>
                <span className="howitworks-section5-job-desc">Niñeras que viven en el hogar y colaboran con el cuidado de los niños durante una cantidad determinada de horas al día. Además de sus tareas, suelen contar con tiempo libre para estudiar o realizar otras actividades.</span>
              </div>
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Encargado/a del hogar o Mayordomo/a:</span>
                <span className="howitworks-section5-job-desc">Gestores del funcionamiento integral de una casa.</span>
              </div>
              <div className="howitworks-section5-row">
                <span className="howitworks-section5-job-title">Personal de limpieza o mantenimiento en empresas:</span>
                <span className="howitworks-section5-job-desc">Trabajadores capacitados para limpiar y mantener espacios comerciales, oficinas o consorcios.</span>
              </div>
            </div>
          </div>
        </div>
        <div className="howitworks-section5-bottom-border"></div>
      </section>

      <section className="howitworks-faq-section">
        <div className="howitworks-faq-inner">
          <h2 className="howitworks-faq-title">
            Lo que tenés que saber antes de empezar
          </h2>
          <div className="howitworks-faq-cards-row">
            <div className="howitworks-faq-card" style={{ backgroundImage: `url(${FaqBg1})` }}>
              <div className="howitworks-faq-card-content">
                <div className="howitworks-faq-card-question">¿Cuánto cuesta usar Happy Home?</div>
                <div className="howitworks-faq-card-answer">
                  Si buscás trabajo, es gratis. Registrate, armá tu perfil y empezá a postularte sin costo. Si querés contratar para tu hogar o empresa, hay una membresía. Por $40.000, accedés a la base de datos, chateás sin límites y publicás hasta dos ofertas.
                </div>
              </div>
            </div>
            <div className="howitworks-faq-card" style={{ backgroundImage: `url(${FaqBg2})` }}>
              <div className="howitworks-faq-card-content">
                <div className="howitworks-faq-card-question">¿Necesito experiencia previa para trabajar?</div>
                <div className="howitworks-faq-card-answer">
                  No es obligatorio, pero si cargás tus experiencias anteriores y referencias, vas a tener más chances de conseguir trabajo. También podés sumar capacitaciones desde nuestra Academia HH.
                </div>
              </div>
            </div>
            <div className="howitworks-faq-card" style={{ backgroundImage: `url(${FaqBg3})` }}>
              <div className="howitworks-faq-card-content">
                <div className="howitworks-faq-card-question">¿Puedo contratar o buscar trabajo desde cualquier parte del país?</div>
                <div className="howitworks-faq-card-answer">
                  ¡Sí! Happy Home está disponible en todas las provincias de Argentina. Podés buscar por tu zona o aplicar a empleos con cama adentro si estás dispuesta/o a mudarte.
                </div>
              </div>
            </div>
            <div className="howitworks-faq-card" style={{ backgroundImage: `url(${FaqBg4})` }}>
              <div className="howitworks-faq-card-content">
                <div className="howitworks-faq-card-question">¿Qué pasa si necesito ayuda durante el proceso?</div>
                <div className="howitworks-faq-card-answer">
                  Nuestro equipo está disponible por WhatsApp para acompañarte en lo que necesites.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="howitworks-contact-section">
        <div className="howitworks-contact-inner">
          <div className="howitworks-contact-left">
            <span className="howitworks-contact-title">Escribinos, estamos para ayudarte.</span>
          </div>
          <div className="howitworks-contact-right">
            <div className="howitworks-contact-links-label">¿Lista/o para empezar?</div>
            <a className="howitworks-contact-link" href="#">
              <img src={Section7IconLeftArrow} alt="Flecha" className="howitworks-contact-link-arrow" />
              <span>Registrarme como empleador/a</span>
            </a>
            <a className="howitworks-contact-link" href="#">
              <img src={Section7IconLeftArrow} alt="Flecha" className="howitworks-contact-link-arrow" />
              <span>Registrarme para trabajar</span>
            </a>
          </div>
        </div>
      </section>

      <section className="howitworks-corporate-section">
        <div className="howitworks-corporate-inner">
          <div className="howitworks-corporate-col-left">
            <div className="howitworks-corporate-title">
              Si buscás personal para<br />tu empresa o institución
            </div>
          </div>
          <div className="howitworks-corporate-col-right">
            <div className="howitworks-corporate-desc">
              También brindamos soluciones a medida para empresas que necesitan personal de limpieza, mantenimiento u operativos, <b>con un proceso ágil y profesional.</b>
            </div>
            <div className="howitworks-corporate-desc">
              Ubicamos el equipo que necesitás, filtramos los perfiles por rubro y zona,<br />
              <b>y te enviamos una propuesta a medida según tu búsqueda.</b>
            </div>
            <a className="howitworks-corporate-btn" href="#">CONOCÉ MÁS SOBRE SOLUCIONES CORPORATIVAS</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HowItWorksPage;
